export const characterTrackerIntroSteps = [
  {
    element: '#help-tour-btn',
    intro: 'Click here to take a tour of this page.'
  },
  {
    element: '#resources-title',
    intro: 'Character Trackers is where you can view and download all of the character trackers that can be used for student engagement.',
  },
];
